<div
  [routerLink]="['/basket']"
  class="basket d-flex justify-content-center align-items-center position-relative c-pointer"
>
  <div class="position-absolute top-50 start-50 translate-middle">
    <i class="bi bi-basket2-fill text-secondary fs-2 cursor-pointer"></i>
  </div>
  @if(counter) {
  <span
    class="position-absolute top-100 start-0 translate-middle badge rounded-circle bg-danger text-white"
  >
    {{ counter }}
  </span>
  }
</div>
